module.exports = __webpack_public_path__ + "media/graceful.f331d337.ogg";